// I don't think a default export makes lot of sense here
// eslint-disable-next-line import/prefer-default-export
export const numberOfVisibleFlags = 6;
